import { HttpClient } from 'api/http-client';
import {
  CreatePartnerPayload,
  PartnerCompany,
  PartnerPermission,
  PartnerUser,
} from './types';

const baseUrl = '/companies';

class PartnerClient extends HttpClient {
  public getAllPartnerCompanies = async () =>
    this.get<PartnerCompany[]>(`${baseUrl}?companyType=PARTNER`);

  public getPartnerCompany = async (companyId: number) =>
    this.get<PartnerCompany>(`${baseUrl}/${companyId}`);

  public createPartnerCompany = async (payload: CreatePartnerPayload) =>
    this.post<PartnerCompany, CreatePartnerPayload>(baseUrl, payload);

  public updatePartnerCompany = async (payload: PartnerCompany) =>
    this.put<PartnerCompany, PartnerCompany>(
      `${baseUrl}/${payload.companyId}`,
      payload,
    );

  public deletePartnerCompany = async (payload: PartnerCompany) =>
    this.delete(`${baseUrl}/${payload.companyId}`);

  public getAllPartnerPermissions = async () =>
    this.get<PartnerPermission[]>('/permission-set/partner');

  public getAllUserInPartnerCompany = async (companyId: number) =>
    this.get<PartnerUser[]>(`${baseUrl}/${companyId}/users`);
}
export const PartnerAPI = new PartnerClient();
